//src/lib/permissions.ts
export const PERMISSIONS = {
  // Dashboard
  DASHBOARD_READ: "dashboard.read",

  // Cadastros
  PEOPLE_READ: "people.read",
  PEOPLE_WRITE: "people.write",

  USERS_READ: "users.read",
  USERS_WRITE: "users.write",
  USERS_PASSWORD_CHANGE: "users.password.change",

  GROUPS_READ: "groups.read",
  GROUPS_WRITE: "groups.write",

  TENANT_READ: "tenant.read",
  TENANT_WRITE: "tenant.write",

  // Administração global Normex / Platform
  PLATFORM_TENANTS_READ: "platform.tenants.read",
  PLATFORM_TENANTS_WRITE: "platform.tenants.write",
  PLATFORM_TENANTS_BOOTSTRAP: "platform.tenants.bootstrap",
  PLATFORM_SMTP_MANAGE: "platform.smtp.manage",
  PLATFORM_AI_CREDITS_MANAGE: "platform.ai_credits.manage",
  PLATFORM_PERMISSIONS_MANAGE: "platform.permissions.manage",
  PLATFORM_FEATURES_READ: "platform.features.read",
  PLATFORM_FEATURES_WRITE: "platform.features.write",

  UNITS_READ: "units.read",
  UNITS_WRITE: "units.write",

  DEPARTMENTS_READ: "departments.read",
  DEPARTMENTS_WRITE: "departments.write",

  JOB_POSITIONS_READ: "job_positions.read",
  JOB_POSITIONS_WRITE: "job_positions.write",

  PERMISSIONS_READ: "permissions.read",

  // Riscos
  RISKS_READ: "risks.read",
  RISKS_WRITE: "risks.write",

  AREAS_READ: "areas.read",
  AREAS_WRITE: "areas.write",

  // Inspeções
  INSPECTIONS_READ: "inspections.read",
  INSPECTIONS_WRITE: "inspections.write",

  // Ações
  ACTIONS_READ: "actions.read",
  ACTIONS_WRITE: "actions.write",

  // Documentos
  DOCUMENTS_READ: "documents.read",
  DOCUMENTS_WRITE: "documents.write",

  // Treinamentos
  TRAININGS_READ: "trainings.read",
  TRAININGS_WRITE: "trainings.write",

  // Relatórios
  REPORTS_READ: "reports.read",
  REPORTS_EXPORT: "reports.export",

  // Notificações
  NOTIFICATIONS_READ: "notifications.read",
  NOTIFICATIONS_WRITE: "notifications.write",

  // Auditoria
  AUDIT_READ: "audit.read",

  // GRO / Psicossocial
  GRO_SETTINGS_READ: "gro.settings.read",
  GRO_SETTINGS_WRITE: "gro.settings.write",

  WORKER_GROUPS_READ: "worker_groups.read",
  WORKER_GROUPS_WRITE: "worker_groups.write",

  QUESTIONNAIRES_READ: "questionnaires.read",
  QUESTIONNAIRES_WRITE: "questionnaires.write",

  SURVEY_CAMPAIGNS_READ: "survey_campaigns.read",
  SURVEY_CAMPAIGNS_WRITE: "survey_campaigns.write",
  SURVEY_CAMPAIGNS_REOPEN: "survey_campaigns.reopen",

  SURVEY_RESULTS_READ: "survey_results.read",

  RISK_INVENTORY_READ: "risk_inventory.read",
  RISK_INVENTORY_WRITE: "risk_inventory.write",

  ACTION_PLANS_READ: "action_plans.read",
  ACTION_PLANS_WRITE: "action_plans.write",
  
} as const;

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ALL_PERMISSIONS: PermissionCode[] = Object.values(PERMISSIONS);

/**
 * Permissões padrão usadas hoje no frontend mockado da tela de grupos.
 * Enquanto a tela de grupos ainda estiver mock, essas listas servem
 * apenas para exibição/edição local.
 */
export const ADMIN_PERMISSIONS: PermissionCode[] = [...ALL_PERMISSIONS];

export const MANAGER_PERMISSIONS: PermissionCode[] = [
  PERMISSIONS.DASHBOARD_READ,

  PERMISSIONS.PEOPLE_READ,
  PERMISSIONS.PEOPLE_WRITE,

  PERMISSIONS.USERS_READ,

  PERMISSIONS.GROUPS_READ,
  PERMISSIONS.UNITS_READ,
  PERMISSIONS.DEPARTMENTS_READ,
  PERMISSIONS.JOB_POSITIONS_READ,

  PERMISSIONS.TENANT_READ,
  PERMISSIONS.PERMISSIONS_READ,

  PERMISSIONS.RISKS_READ,
  PERMISSIONS.RISKS_WRITE,

  PERMISSIONS.AREAS_READ,
  PERMISSIONS.AREAS_WRITE,

  PERMISSIONS.INSPECTIONS_READ,
  PERMISSIONS.INSPECTIONS_WRITE,

  PERMISSIONS.ACTIONS_READ,
  PERMISSIONS.ACTIONS_WRITE,

  PERMISSIONS.DOCUMENTS_READ,
  PERMISSIONS.DOCUMENTS_WRITE,

  PERMISSIONS.TRAININGS_READ,
  PERMISSIONS.TRAININGS_WRITE,

  PERMISSIONS.REPORTS_READ,
  PERMISSIONS.REPORTS_EXPORT,

  PERMISSIONS.NOTIFICATIONS_READ,
  PERMISSIONS.NOTIFICATIONS_WRITE,

  PERMISSIONS.AUDIT_READ,
];

export const OPERATOR_PERMISSIONS: PermissionCode[] = [
  PERMISSIONS.DASHBOARD_READ,

  PERMISSIONS.PEOPLE_READ,

  PERMISSIONS.UNITS_READ,
  PERMISSIONS.DEPARTMENTS_READ,
  PERMISSIONS.JOB_POSITIONS_READ,

  PERMISSIONS.RISKS_READ,
  PERMISSIONS.RISKS_WRITE,

  PERMISSIONS.AREAS_READ,

  PERMISSIONS.INSPECTIONS_READ,
  PERMISSIONS.INSPECTIONS_WRITE,

  PERMISSIONS.ACTIONS_READ,
  PERMISSIONS.ACTIONS_WRITE,

  PERMISSIONS.DOCUMENTS_READ,

  PERMISSIONS.TRAININGS_READ,

  PERMISSIONS.REPORTS_READ,

  PERMISSIONS.NOTIFICATIONS_READ,
];
